<template>
  <b-card :title="title">
    <div class="pie-text text-center">
      <h2 class="font-weight-bolder">
        {{ total }}
      </h2>
      <span class="font-weight-bold">کل داده ها</span>
    </div>
    <!-- echart -->
    <app-echart-doughnut :series="series" />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut.vue'

export default {
  components: {
    BCard,
    AppEchartDoughnut,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      series: [
        {
          name: 'Visit source',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: this.data,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.card-body{
  position: relative;
  .pie-text{
    width: 105px;
    position:absolute;
    margin: auto;
    left: 0;
    right: 0%;
    top: 50%;
    bottom: 0;
  }
}
</style>
